import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { APP_CONSTANTS } from '@pendwa/common/utils/constants.js';
import { captureException } from '@sentry/browser';
import React from 'react';
import { appStore } from '../../core/appStore/index.js';
import { usePageData } from '../../hooks/pageData/usePageData.js';
export var EnumDisplayLanguage;
(function (EnumDisplayLanguage) {
    EnumDisplayLanguage["english"] = "English";
    EnumDisplayLanguage["swahili"] = "Swahili";
})(EnumDisplayLanguage || (EnumDisplayLanguage = {}));
export const getPersistedDisplayLanguageDuoCode = () => {
    try {
        const persisted_code = appStore.get(APP_CONSTANTS.CHOOSE_DISPLAY_LANGUAGE_DUO_STORAGE_KEY);
        if (persisted_code === EnumDisplayLanguage.english) {
            return EnumDisplayLanguage.english;
        }
        if (persisted_code === EnumDisplayLanguage.swahili) {
            return EnumDisplayLanguage.swahili;
        }
        return undefined;
    }
    catch (error) {
        captureException(error);
        return undefined;
    }
};
export const ContextPageData = React.createContext({
    error: undefined,
    refetch: () => undefined,
    loading: false,
    viewer: undefined,
    viewer_profile: undefined,
    viewer_profiles: [],
    currency: undefined,
    display_language: EnumDisplayLanguage.english,
    setDisplayLanguage: () => { },
});
export const ContextPageDataWrapper = (props) => {
    const [display_language, setDisplayLanguage] = React.useState(getPersistedDisplayLanguageDuoCode() ?? EnumDisplayLanguage.english);
    const pageData = usePageData();
    return (_jsx(_Fragment, { children: _jsx(ContextPageData.Provider, { value: {
                ...pageData,
                display_language,
                setDisplayLanguage,
            }, children: props.children }) }));
};
//# sourceMappingURL=index.js.map